import React, { useEffect, useState } from "react";
import { FxmsData } from "./../datas/FxData"
import FxCompanyLineChart from "./charts/FxCompanyLineChart";
import { FxWindow } from "../windows/FxWindows";
/**
 * 산단대시보드 공장 하이차트 컴포넌트
 * 개발자 : 최선하
 * 개발년월 : 2022.12
 * @param {*} props
 * @returns
 */
export const FxCompanyPopup = (props) => {
  const {inloNo, prodDateStart, prodDateEnd} = props
  const [engResult, setEngResult] = useState(0);
  const [result, setResult] = useState([{}]);

  useEffect(() => {

    showData()
  }, [])

  const para = {};
  para.inloNo = inloNo;
  para.prodDateStart = prodDateStart;
  para.prodDateEnd = prodDateEnd;

  let eng = 0;          // 적산값 담는 변수

  const inputEng = (data) => {
    eng += Math.floor(data.prodAmt);
    setEngResult(eng.toLocaleString('ko-KR'));
  }

  function showData (inputData) {
    FxmsData.GET("vup/dash/companyPopup", para)
      .then(function (res) {
        setResult(res.data);

        FxWindow.alert(res.data.length + " 건의 데이터가 조회되었습니다.");

        for (let data of res.data) {
          if (props.engId == data.engId) {
            inputEng(data)
          }
        }
      })
      .catch(function (res) {
        FxWindow.alert("조회중 오류가 발행되었습니다.", true);
      })
  }

  return (
    <>
    <div className="popupChartArea" >
      <div className="titlePart">
          <div style={{color: "#00bdfe"}}>{props.engAddName}</div>
          <div style={{fontSize: 40,fontWeight: "600"}}>{engResult} {props.engUnitName}</div>
      </div>
      <div className="chartPart">
          <FxCompanyLineChart
          engMap={result}
          engId={props.engId}
          engUnit={props.engUnitName}
          color={props.color}
          />
      </div>
    </div>
    <hr/>
    </>
  )
}